import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../../../services/authentication/login.service';
import { ApiService } from '../../../../../services/main/api.service';
import { Global } from '../../../../../services/global';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { Observable, from, of } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { BaseCrudComponent } from '../../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Storage } from '@ionic/storage';
import { Lightbox } from 'ngx-lightbox';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-trackingreport',
  templateUrl: './trackingreport.component.html',
  styleUrls: ['./trackingreport.component.css']
})

export class TrackingreportComponent extends BaseCrudComponent {

	myid:any;
    orderid:any;
	extid:any;
    loadingOrder = false;

	translations:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    mysearch:any;

    orders:any;
    oheaders:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = '';
        this.rows = [];
        this.orders = [];
        this.mysearch = '';

        this.theaders = [
        	{ field: 'guideNumber', header: 'Guía', styleC:{'text-align':'center'}, width:{'width.px': 150} },
        	{ field: 'clientName', header: 'Cliente', styleC:{'text-align':'center'}, width:{'width.px': 200} },
        	{ field: 'date', header: 'Fecha', styleC:{'text-align':'center'}, width:{'width.px': 150} },
        	{ field: 'deliveryStatus', header: 'Estado', styleC:{'text-align':'center'}, width:{'width.px': 150} }
        ];

        this.oheaders = [
            { field: 'guideNumber', header: 'Guía', styleC:{'text-align':'center'}, width:{'width.px': 150} },
            { field: 'clientName', header: 'Cliente', styleC:{'text-align':'center'}, width:{'width.px': 200} },
            { field: 'date', header: 'Fecha', styleC:{'text-align':'center'}, width:{'width.px': 150} },
            { field: 'deliveryStatus', header: 'Estado', styleC:{'text-align':'center'}, width:{'width.px': 150} }
        ];
    }

    ngOnInit() {
    	let today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = today;
        this.f_dateto = today;

        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
            this.translations = translations;
            super.ngOnInit();
        });
    }

    public getList(){
        var qst = 'LogisticDestination/TrackingGuide';
        var obj:any;

        if( this.mysearch == '' ){
        	return;
        }

        this.rows = [];
        obj = {
        	clientName: this.mysearch,
            Start: this.f_datefrom,
            End: this.f_dateto
        }

        this.loadingList = true;

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.rows = rs;
            }
        });
    }

	queryGuide(id:any){
		if( id != '' ){
			this.extid = id;
		}
	}

    public getOrdersList(id:any){
        var qst = 'LogisticDestination/TrackingOrder';
        var obj:any;

        if( id == '' ){
            return;
        }

        this.orders = [];
        obj = {
            order: id
        }

        this.loadingOrder = true;

        this.srv.postCall(qst, obj).subscribe(x => {
            this.loadingOrder = false;

            if(x.status){
                var rs = x.data;
                this.orders = rs;
            }
        });
    }

    /*queryOrder(id:any){
        if( id != '' ){
            var qst = 'LogisticClient/InfoOrder/' + id;
            this.extid = undefined;
            this.loadingOrder = true;

            this.srv.getCall(qst).subscribe(x => {
                this.loadingOrder = false;

                if(x.status){
                    if( Array.isArray(x.data) && (x.data.length > 0) ){
                        let guideId = x.data[0]['guideNumber'];
                        this.extid = guideId;
                    }
                }
            });
        }
    }*/

	showTracking(id:any){
        //console.log(id);
		//this.myid = id;
        this.queryGuide(id);
	}
}
